import styled from '@emotion/styled'
import { Swiper, SwiperSlide } from 'swiper/react'

export const StyledRowOfDaysContainer = styled('div')(({ theme }) => ({
  marginBottom: '24px',
}))

export interface StyledDayButtonProps {
  isSelected?: boolean
}

export const StyledDayButton = styled('span')<StyledDayButtonProps>(({ isSelected, theme }) => ({
  background: isSelected ? theme.rowOfDays.secondary : theme.rowOfDays.primary,
  color: isSelected ? theme.rowOfDays.textSecondary : theme.rowOfDays.text,
  borderRadius: '1px',
  fontSize: '12px',
  maxHeight: '26px',
  padding: '6px 16px',
  fontWeight: 500,
  cursor: 'pointer',
}))

export const StyledSwiperSlide = styled(SwiperSlide)(({ theme }) => ({
  width: 'auto',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
}))

export const StyledSwiper = styled(Swiper)(({ theme }) => ({}))
